const setDaikinThermostatsList = (context, thermostatsList) => {
  context.commit('DAIKIN_THERMOSTATS_LIST', thermostatsList);
};

export default {
  setDaikinThermostatsList,
};
